<template>
  <MglMap
    :accessToken="options.accessToken"
    :mapStyle="options.mapStyle"
    @load="onMapLoaded"
  />
</template>

<script>
import Mapbox from "mapbox-gl";
import { MglMap } from "vue-mapbox";
require('!style-loader!css-loader!mapbox-gl/dist/mapbox-gl.css')


export default {
  name: "DroneMap",
  components: {
    MglMap
  },
  data() {
    return {
      options: {
        accessToken: 'pk.eyJ1IjoiamVyeWluaSIsImEiOiJjazlsN2ozdTAwM2VrM2RwYmZsdDhobDN2In0.YqDjF-vIUFzPWazAP4KFSg', // your access token. Needed if you using Mapbox maps
        mapStyle: 'mapbox://styles/jeryini/ckiekew5s3q9p19k0k8k74419', // streets style, edit it at: https://studio.mapbox.com/
      },
      droneSourceData:  {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-122.4194, 37.7749] // default starting point - SF
        },
        properties: {}
      },
      homePointSourceData:  {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [-122.4194, 37.7849] // default starting point - SF
        },
        properties: {}
      },
      droneLayoutData: {
        'icon-image': 'drone',
        'icon-rotate': 0,
        'visibility': 'visible',
      },
      droneRouteSourceData:  {
        type: "Feature",
        geometry: {
          type: "LineString",
          coordinates: [] // default is empty
        },
        properties: {}
      },
      initialFly: true,
    };
  },

  created() {
    // We need to set mapbox-gl library here in order to use it in template
    this.mapbox = Mapbox;

    // set after load event, it will contain Mapbox GL JS Map object
    // https://docs.mapbox.com/mapbox-gl-js/api/map/
    this.map = null;
  },

  methods: {
    onMapLoaded(event) {
      this.map = event.map;
      let ref = this;

      this.map.on('click', function() {
        ref.$emit('mapclicked');
      })

      // drone route source
      this.map.addSource('droneRoute', {
        type: 'geojson',
        data: this.droneRouteSourceData
      });

      // drone route layer
      this.map.addLayer({
        'id': 'droneRoute',
        'type': 'line',
        'source': 'droneRoute',
        'layout': {
          'line-join': 'round',
          'line-cap': 'round'
        },
        'paint': {
          'line-color': '#ff0000',
          'line-width': 2
        }
      });

      // homePoint source
      this.map.addSource('homePoint', {
        type: 'geojson',
        data: this.homePointSourceData
      });

      // home point layer
      this.map.addLayer({
        'id': 'homePoint',
        'type': 'symbol',
        'source': 'homePoint',
        'layout': {
          'icon-image': 'home',
          'visibility': 'visible',
        },
      });

      // drone source
      this.map.addSource('drone', {
        type: 'geojson',
        data: this.droneSourceData
      });

      // drone layer
      this.map.addLayer({
        'id': 'drone',
        'type': 'symbol',
        'source': 'drone',
        'layout': this.droneLayoutData,
      });

      this.map.getLayoutProperty('drone', 'visibility');
    },
    resizeMap() {
      let mapCanvas = document.getElementsByClassName('mapboxgl-canvas')[0];

      mapCanvas.style.width = '100%';
      mapCanvas.style.height = '100%';

      let ref = this;

      // delay is needed as otherwise map is resized before CSS is applied and that does not work properly
      setTimeout(function(){ ref.map.resize(); }, 10);
    },
    updateMap(telemetryData) {
      if (telemetryData.location) {
        this.droneSourceData.geometry.coordinates = [telemetryData.location.drone.longitude, telemetryData.location.drone.latitude];
        this.droneRouteSourceData.geometry.coordinates.push([telemetryData.location.drone.longitude, telemetryData.location.drone.latitude]);

        if (telemetryData.location.home) {
          this.homePointSourceData.geometry.coordinates = [telemetryData.location.home.longitude, telemetryData.location.home.latitude];
        }

        this.map.getSource('homePoint').setData(this.homePointSourceData);
        this.map.getSource('drone').setData(this.droneSourceData);
        this.map.getSource('droneRoute').setData(this.droneRouteSourceData);
      }

      if (telemetryData.attitude) {
        this.droneLayoutData['icon-rotate'] = telemetryData.attitude.heading;
        this.map.setLayoutProperty('drone', 'icon-rotate', telemetryData.attitude.heading);
      }

      if (this.initialFly) {
        this.map.jumpTo({
          center: this.droneSourceData.geometry.coordinates,
          zoom: 14,
        });
        this.initialFly = false;
      } else {
        this.map.flyTo({
          center: this.droneSourceData.geometry.coordinates,
        });
      }
    }
  }
};
</script>
